import { inject } from '@angular/core';
import { GvTaTrackerAssignmentApiService } from '@shared/services';
import { PopoverHandlerConfig, PopoverConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { updateTrackerAssignmentFormConfig } from '@shared/components/edit-create-form';

export const updateTrackerAssignmentPopoverConfig = (
    onSuccess: () => void,
    onCancel: () => void
): PopoverConfig => {
    const trackerAssignmentApiService = inject(GvTaTrackerAssignmentApiService);

    return {
        width: '500px',
        title: 'Cập nhật phân công Tracker',
        dismissable: true,
        styleClass: 'p-fluid',
        formConfig: updateTrackerAssignmentFormConfig(),
        actions: [defaultCancelAction, defaultConfirmAction],
        handlerConfig: {
            service: trackerAssignmentApiService,
            method: 'updateAssignment',
            entityLabel: 'cập nhật phân công',
            commonDataTransform: (formValue: any) => ({
                id: formValue.id,
                fromDate: formValue.fromDate,
                toDate: formValue.toDate
            }),
            initialDataTransform: (rawData: any) => ({
                id: rawData.id,
                gvTaEmployeePosition: rawData.gvTaEmployeePosition,
                trackerEmployeePosition: rawData.trackerEmployeePosition,
                fromDate: rawData.fromDate ? new Date(rawData.fromDate) : null,
                toDate: rawData.toDate ? new Date(rawData.toDate) : null
            }),
            onSuccess,
            onCancel
        } as PopoverHandlerConfig
    };
};

